import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";

import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Stack from "@mui/material/Stack";
import { alpha } from "@mui/material/styles";
import AppNavbar from "./v2/dashboard/components/AppNavbar";
import Header from "./v2/dashboard/components/Header";
import {
  chartsCustomizations,
  dataGridCustomizations,
  datePickersCustomizations,
  treeViewCustomizations,
} from "./v2/dashboard/theme/customizations";
import AppSideMenu from "./v2/home/AppSideMenu";
import AppTheme from "./v2/shared-theme/AppTheme";

const drawerWidth = 0;
const collapsedDrawerWidth = 0; // Adjust as needed, e.g., 80

const xThemeComponents = {
  ...chartsCustomizations,
  ...dataGridCustomizations,
  ...datePickersCustomizations,
  ...treeViewCustomizations,
};

const Layout = (props) => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = React.useState(
    localStorage.getItem("sidebarCollapsed") === "true" || false
  );

  useEffect(() => {
    //sessionStorage.getItem("user");
    console.log("Effect running on every re-render");
  });

  // const userRoles = getUserRoles(); // Kept if needed elsewhere, currently unused in this logic
  // const hasRole = (roleList) =>
  //   roleList?.some((role) => userRoles.includes(role));

  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
    localStorage.setItem("sidebarCollapsed", !isSidebarCollapsed);
  };

  return (
    <AppTheme {...props} themeComponents={xThemeComponents}>
      <CssBaseline enableColorScheme />
      <Box sx={{ display: "flex" }}>
        <AppSideMenu
          isCollapsed={isSidebarCollapsed}
          toggleSidebar={toggleSidebar}
        />
        <AppNavbar />
        <Box
          component="main"
          sx={(theme) => ({
            flexGrow: 1,
            marginLeft: {
              xs: 0,
              md: isSidebarCollapsed
                ? `${collapsedDrawerWidth}px`
                : `${drawerWidth}px`,
            },
            transition: theme.transitions.create("margin", {
              easing: theme.transitions.easing.sharp,
              duration: isSidebarCollapsed
                ? theme.transitions.duration.leavingScreen
                : theme.transitions.duration.enteringScreen,
            }),
            backgroundColor: theme.vars
              ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
              : alpha(theme.palette.background.default, 1),
            overflow: "auto",
          })}
        >
          <Stack
            spacing={2}
            sx={{
              alignItems: "center",
              mx: 1,
              pb: 5,
              mt: { md: 0 },
            }}
          >
            <Header isSidebarCollapsed={isSidebarCollapsed} />
            <Outlet />
          </Stack>
        </Box>
      </Box>
    </AppTheme>
  );
};
export default Layout;
